import React from 'react';

const JS_Google_Chart = () => {
  return (
    <div >
      <h1>JS_Google_Chart</h1>
      <p>Placeholder component for: "JS Google Chart"</p>
    </div>
  );
};

export default JS_Google_Chart;
